import React from 'react';
import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { rssFeedSelector } from '@mm/state/modules/rssFeedTableState/selectors';
import EmptyPageBacksplash from '../../../../common/EmptyPageBacksplash/EmptyPageBacksplash';
import RssFeedsTableWithFeeds from './RssFeedsTableWithFeeds';
import RssFeedCRUDActions from '@mm/state/actions/RssFeedCRUDActions';
import rssBlasterImg from 'assets/feature-svgs/rss-blaster.svg';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { LifeCycleThis } from '@mm/utils';
import { RouterComponentProps } from '../../../../../common/helpers/routes/interfaces';
import { withRouter } from 'react-router';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { PrimaryButton } from '../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { PlusCircleIcon } from '@mm/icons';

type OuterProps = {
  createFeed: (e) => void;
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouterComponentProps;

type Props = OuterProps & InnerProps;

const RssFeedsTable = ({ entities, createFeed }: Props) => {
  const hasRssFeeds = entities && entities.length > 0;

  if (hasRssFeeds) {
    return (
      <div className="shared-panel__main-container">
        <RssFeedsTableWithFeeds feeds={entities} />
      </div>
    );
  }

  return (
    <EmptyPageBacksplash pageIcon={rssBlasterImg}>
      <PrimaryButton leftIcon={<PlusCircleIcon />} onClick={createFeed}>
        New RSS Blaster
      </PrimaryButton>
    </EmptyPageBacksplash>
  );
};

const mapStateToProps = (state: StoreState) => ({
  activeChatbotId: activeChatbotIdSelector(state),
  entities: rssFeedSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  getEntities: (botId: number) => {
    dispatch(RssFeedCRUDActions.retrieveAll(botId));
  },
});

function componentDidMount(this: LifeCycleThis<Props>) {
  const { getEntities, activeChatbotId } = this.props;

  if (activeChatbotId !== -1) {
    getEntities(activeChatbotId);
  }
}

function componentDidUpdate(this: LifeCycleThis<Props>, prevProps: Props) {
  const { getEntities, activeChatbotId } = this.props;
  const { activeChatbotId: prevChatbotId } = prevProps;

  if (prevChatbotId !== activeChatbotId && activeChatbotId !== -1) {
    getEntities(activeChatbotId);
  }
}

const enhance = compose<InnerProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle<Props, {}>({ componentDidMount, componentDidUpdate }),
);

export default enhance(RssFeedsTable);
